export default function cloneObject(obj) {
  const str = JSON.stringify(obj);
  return JSON.parse(str);
}